module.exports = __webpack_public_path__ + "static/media/model-home-printing-3d-object.aa9481c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/model-home-printing-3d-object.jpg
// module id = 418
// module chunks = 0